import { Base } from '@studiometa/js-toolkit';

/**
 * Newsletter class.
 */
export default class Newsletter extends Base {
  static config = {
    name: 'Newsletter',
    refs: ['btnClose'],
    options: {
      delay: {
        type: Number,
        default: 7000,
      },
    },
  };

  /**
   * Mounted
   */
  mounted() {
    if (localStorage.getItem('newsletter_displayed')) {
      return;
    }

    setTimeout(() => {
      this.showPopin();
    }, this.$options.delay);
  }

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (this.opened && ESC) {
      this.closePopin();
    }
  }

  /**
   * Close on click
   * @returns {void}
   */
  onBtnCloseClick() {
    this.closePopin();
  }

  /**
   * Show Popin
   * @returns {void}
   */
  showPopin() {
    localStorage.setItem('newsletter_displayed', true);
    this.opened = true;
    this.$el.classList.remove('opacity-0', 'pointer-events-none');
  }

  /**
   * Close popin
   * @returns {void}
   */
  closePopin() {
    this.opened = false;
    this.$el.classList.add('opacity-0', 'pointer-events-none');
  }
}
